export default __webpack_public_path__ + "c3e123cf78bc368a192f3e2dee97daba.svg";